import DropdownOption from "@/entities/DropdownOption";
import TagsMultiselectOption from "@/entities/TagMultiselectOption";

function filterMultiselectItems<T extends DropdownOption | TagsMultiselectOption > (idsList: string[], chosenItems: T[] ): {
  previouslyChosenItems: T[], newItemsIds: string[]
} {
  const previouslyChosenItems =
    chosenItems.filter(chosenItem => (
      idsList.some(id => id === chosenItem.id)
    ));

  const newItemsIds =
    idsList.filter(id => (
      chosenItems.every(chosenItem => chosenItem.id !== id)
    ));

  return {
    previouslyChosenItems,
    newItemsIds,
  }
}

export default filterMultiselectItems;